import { useTracking } from 'react-tracking';
import { useMemo } from 'react';

import merge from 'deepmerge';

export const UTAG_LINK = "link";
export const UTAG_VIEW = "view";

export function formatUTagLinkData(content) {
    return merge({ action: UTAG_LINK }, formatTrackingData(content));
}

export function formatUTagViewData(content) {
    return merge({ action: UTAG_VIEW }, formatTrackingData(content));
}

export function formatTrackingData(content) {
    return ({ payload: content});
}

export default function useUTag() {
    const { trackEvent, getTrackingData } = useTracking();

    return useMemo(() => ({
        link: (data) => trackEvent(formatUTagLinkData(data)),
        view: (data) => trackEvent(formatUTagViewData(data)),
        linkEvent: (data = {}, eventFn) => { 
            trackEvent(formatUTagLinkData(data));
            if (eventFn)
                return eventFn() 
        },
        getTrackingData: getTrackingData
    }), [trackEvent, getTrackingData]);
}

export function createUTagTrackingPayload() {
    return { 
        payload: {
            app: "dashboard-app" 
        }
    };
}

export function createUTagTrackingOptions() {
    return {
        dispatch: data => {
            switch (data.action) {
                case UTAG_LINK:
                    window.utag.link(data.payload);
                    break;
                case UTAG_VIEW:
                    window.utag.view(data.payload);
                    break;
                default:
                    break;
            }
        },
        process: (data) => (data.payload.viewComponent ? formatUTagViewData({ event: "component-ready", component: data.payload.viewComponent }) : null)
    };
}